export enum Constants {
  SET_SPORT = '@lateSwap/set_sport',
  SET_SITE = '@lateSwap/set_site',
  SET_SLATE = '@lateSwap/set_slate',
  SET_GENERATED_SLATE = '@lateSwap/set_generated_slate',
  SET_LOADING = '@lateSwap/set_loading',
  SET_POOL_SIZE = '@lateSwap/set_pool_size',
  SET_PERCENT_TO_FIRST = '@lateSwap/set_percent_to_first',
  SET_LIVE_CONTEST_ID = '@lateSwap/set_live_contest_id',
  SET_CONTEST_PLAYERS = '@lateSwap/set_contest_players',
  SET_CONTEST_GEN_LINEUPS = '@lateSwap/set_contest_gen_lineups',
  SET_CONTEST_LINEUPS = '@lateSwap/set_contest_lineups',
  SET_CONTEST_STACKS = '@lateSwap/set_contest_stacks',
  SET_EXPORTABLE_LINEUPS = '@lateSwap/set_exportable_lineups',
  SET_BOOST_PLAYER = '@lateSwap/set_boost_player',
  REMOVE_BOOST_PLAYER = '@lateSwap/remove_boost_player',
  CLEAR_BOOST_PLAYERS = '@lateSwap/clear_boost_players',
  SET_CONSTRAINTS = '@lateSwap/set_constraints',
  SET_RUNBACK = '@lateSwap/set_runback',
  SET_DIVERSITY = '@lateSwap/set_diversity',
  SET_LINEUP_DIVERSITY = '@lateSwap/set_lineup_diversity',
  USE_CUSTOM_EXPOSURES = '@lateSwap/use_custom_exposures',
}